<template>
  <v-row no-gutters class="ma-0" aria-label="Opciones de consulta">
    <v-col cols="12">
      <v-row align="center" justify="center" class="mt-5">
        <v-col cols="12" md="11">
          <v-row align="center" justify="center" class="mx-0">
            <v-col
              cols="6"
              md="2"
              sm="4"
              v-for="(item, index) in items"
              :key="index"
              class="ma-1"
              v-show="
                !item.guards ||
                (
                  isAuth &&
                  getUserRoles &&
                  (
                    item.guards.some(el => getUserRoles.includes(el)) ||
                    getUserRoles.includes('Admin')
                  )
                )
              "
              >
              <v-hover v-slot:default="{ hover }">
                <v-card
                  :min-height="$vuetify.breakpoint.md ? 200 : 150"
                  :to="item.url"
                  :ripple="false"
                  class="py-0"
                  :color="
                    $vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3'
                  "
                  shaped
                  :style="hover ? 'opacity: 0.8' : ''"
                  :title="item.title"
                >
                  <v-card-text>
                    <div class="text-center">
                      <v-icon size="40" :color="hover ? 'leading' : ''">
                        {{
                        item.icon
                        }}
                      </v-icon>
                    </div>
                    <div
                      :class="
                        `${
                          hover
                            ? 'leading--text font-weight-medium'
                            : 'font-weight-medium'
                        } mt-6 text-center`
                      "
                      style="line-height: 1.5"
                    >{{ item.title }}</div>
                  </v-card-text>
                  <v-tabs-slider class="barra_" centered grow :color="selectcolor[index]"></v-tabs-slider>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    items: Array
  },
  computed: {
    ...mapGetters("auth", ["isAuth", "getUserRoles"]),
  },
  data: () => ({
    selectcolor: [
      "#91be91",
      "#ffd20f",
      "#4f90c8",
      "#cb302f",
      "#0a7a39",
      "#65c0e7",
      "#FF6F00",
      "#264899"
    ],
    color: ["#91be91", "#ffd20f", "#4f90c8", "#cb302f", "#0a7a39", "#65c0e7"],
  }),
  created() {
    this.$store.dispatch("process/clearProcesos");
    this.$store.dispatch("process/setUrlAyuda", "/manual");
  },
};
</script>
<style scoped>
.v-card {
  /* transition: opacity .4s ease-in-out; */
  display: flex;
  align-items: center;
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.v-card:before {
  background: none !important;
}

.v-card:hover {
  color: blue;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transform: scale(1.1);
}

.barra_ {
  height: 4px;
  position: absolute;
  bottom: 0;
  width: 91%;
}
</style>
